const reductions = {

    SET_ACCOUNT : (state, action) => {
        return action.payload;
    },

    UNSET_ACCOUNT : () => {
        return null
    }
};

const reducer = (state = null, action) => {
    if(action && action.type && reductions[action.type]) {
        return reductions[action.type](state, action)
    }
    return state;
};

export default reducer;